module.exports = kolibriCoreAppGlobal.coreVue.vuex.store;